module.exports = __webpack_public_path__ + "static/media/Savannah-Alt-Regular.fcaa135f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Savannah-Alt-Regular.ttf
// module id = 3411
// module chunks = 51